import * as PIXI from 'pixi.js'
import {Signals} from "@/Imports";

export default class TickerGenerator {
    constructor() {
        Signals.tickerStart.add(this.start.bind(this))
        Signals.tickerStop.add(this.stop.bind(this))
        this.ticker = new PIXI.Ticker()
        this.ticker.autoStart = true

        this.ticker.add(time => {
            this.update()
        })
    }

    start() {
        this.ticker.start()
    }

    stop() {
        this.ticker.stop()
    }


    update () {
        Signals.tick.dispatch()
    }
}

new TickerGenerator()